import styled from 'styled-components';

const ColumnRangeContainer = styled.div`
  .x-axis {
    font-size: 32px;
  }
`;
export default ColumnRangeContainer;
